import { createFileRoute, redirect } from '@tanstack/react-router'

// Default to form tab when accessing /campaigns/create
export const Route = createFileRoute('/campaigns/create/')({
  beforeLoad: () => {
    throw redirect({ to: '/campaigns/create/form' })
  },
})
